import ActionTypes from '../constants/ActionTypes';

/* Events */

export const fetchAlertsRequested = () => ({
  type: ActionTypes.ALERTS_FETCH_REQUESTED,
  payload: {},
});

export const fetchAlertsSucceeded = (alerts) => ({
  type: ActionTypes.ALERTS_FETCH_SUCCEEDED,
  payload: {
    alerts,
  },
});

export const fetchAlertsFailed = (error) => ({
  type: ActionTypes.ALERTS_FETCH_FAILED,
  payload: {
    error,
  },
});

export const fetchAlertsOccurRequested = () => ({
  type: ActionTypes.ALERTS_OCCUR_FETCH_REQUESTED,
  payload: {},
});

export const fetchAlertsOccurSucceeded = (alerts) => ({
  type: ActionTypes.ALERTS_OCCUR_FETCH_SUCCEEDED,
  payload: {
    alerts,
  },
});

export const fetchAlertsOccurFailed = (error) => ({
  type: ActionTypes.ALERTS_OCCUR_FETCH_FAILED,
  payload: {
    error,
  },
});

export const fetchAlertsResRequested = () => ({
  type: ActionTypes.ALERTS_RES_FETCH_REQUESTED,
  payload: {},
});

export const fetchAlertsResSucceeded = (alerts) => ({
  type: ActionTypes.ALERTS_RES_FETCH_SUCCEEDED,
  payload: {
    alerts,
  },
});

export const fetchAlertsResFailed = (error) => ({
  type: ActionTypes.ALERTS_RES_FETCH_FAILED,
  payload: {
    error,
  },
});

export const updateAlertsDisplayed = () => ({
  type: ActionTypes.ALERT_DISPLAYED,
  payload: {},
});

export const fetchAlertDataRequested = (deviceId, data) => ({
  type: ActionTypes.ALERT_DATA_FETCH_REQUESTED,
  payload: {
    deviceId,
    data,
  },
});

export const fetchAlertDataSucceeded = (alertId, alertDatas) => ({
  type: ActionTypes.ALERT_DATA_FETCH_SUCCEEDED,
  payload: {
    alertId,
    alertDatas,
  },
});

export const fetchAlertDataFailed = (error) => ({
  type: ActionTypes.ALERT_DATA_FETCH_FAILED,
  payload: {
    error,
  },
});
